import Splide from '@splidejs/splide';

(() => {
  const query = document.querySelector('.mobile .features-container');
  if (!query) return;

  const splide = document.createElement('div');
  splide.classList.add('splide', 'features-splide');
  const splideTrack = document.createElement('div');
  splideTrack.classList.add('splide__track');
  const splideList = document.createElement('div');
  splideList.classList.add('splide__list');

  const slides = query.querySelectorAll('.feature-item');
  slides.forEach((slide) => {
    const slideItem = document.createElement('div');
    slideItem.classList.add('splide__slide');
    slideItem.innerHTML = slide.outerHTML;
    splideList.appendChild(slideItem);
  });

  splideTrack.appendChild(splideList);
  splide.appendChild(splideTrack);

  query.appendChild(splide);

  new Splide(splide, {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    gap: '1rem',
    arrows: false,
  }).mount();
})();
